module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Roman.12fe7b0d.woff2";